import { firebaseModule } from '../../../../shared/app/vendor/firebase-module';
import {
  RUN_TRIGGER_PATH,
  RUN_TYPE_SUBMIT,
  RUN_TYPE_TESTS,
  SUBMIT_COMPLETED,
  SUBMIT_PATH,
  SUBMIT_RUNNING,
} from '../../../../shared/app/services/live-interview-service/live-interview-service';

export const challengeRouteInteractHelperModule = angular
  .module('Q.helpers.challenge-route-interact-helper', [firebaseModule])

  .factory('challengeRouteInteractHelper', function (firebase) {
    /**
     * Sets up basic listeners for Interact event triggers
     * @param ctrl
     * @param assessmentResultProcess
     * @param $scope
     */
    function init(ctrl, assessmentResultProcess, $scope) {
      const challengeProcess = ctrl.process;
      let unwatchTrigger = null;
      const firebaseRef = assessmentResultProcess.liveInterview.firebaseRef;
      firebase.get(firebaseRef + RUN_TRIGGER_PATH).then((triggerRef) => {
        unwatchTrigger = triggerRef.$watch(() => {
          let res = false;
          if (triggerRef.$value === RUN_TYPE_TESTS) {
            res = ctrl.runTests();
          } else if (triggerRef.$value === RUN_TYPE_SUBMIT) {
            res = ctrl.submitSolution();
          }

          if (triggerRef.$value) {
            triggerRef.$remove();
          }

          if (res === false) {
            // clear anything waiting
            challengeProcess.startRun().finally(challengeProcess.endRun);
          }
        });
      });
      $scope.$on('$destroy', () => {
        if (unwatchTrigger) unwatchTrigger();
      });

      ctrl.startSubmitSolution = () => {
        firebase.set(firebaseRef + SUBMIT_PATH, {
          id: ctrl.challenge.id,
          state: SUBMIT_RUNNING,
          ts: Date.now(),
        });
      };
      ctrl.endSubmitSolution = () => {
        firebase.set(firebaseRef + SUBMIT_PATH, {
          id: ctrl.challenge.id,
          state: SUBMIT_COMPLETED,
          ts: Date.now(),
        });
      };
    }

    return {
      init,
    };
  });
